import { render } from "./ReferralModules.vue?vue&type=template&id=7142219c&scoped=true&lang=pug"
import script from "./ReferralModules.vue?vue&type=script&lang=js"
export * from "./ReferralModules.vue?vue&type=script&lang=js"

import "./ReferralModules.vue?vue&type=style&index=0&id=7142219c&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7142219c"]])

export default __exports__